import { primary, yellow } from "@/styles/variable"
import styled from "styled-components"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: ${primary.background};
  text-align: center;
  padding: 0 20px;
`

export const Title = styled.h1`
  font-size: 5rem;
  color: ${yellow.FF};
  margin-bottom: 20px;
`

export const Subtitle = styled.p`
  font-size: 1.5rem;
  color: ${primary.white};
  margin-bottom: 20px;
`

export const Button = styled.a`
  margin-top: 30px;
  padding: 20px 40px;
  background-color: ${yellow.FF};
  color: ${primary.black};
  text-decoration: none;
  border-radius: 20px;
  font-size: 1.5rem;
  font-weight: bold;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${yellow.FF0};
  }
`
